import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Loader from "../Loader/Loader";
import OrderFilterModal from "./OrderFilterModal";
import { format, parse } from "date-fns";
import ProductDetailsModal from "./ProductDetailModal";
import FullStatement from "../transactionReport/FullStatement";
import DownloadReport from "../transactionReport/DownloadReport";
import { useSelector } from "react-redux";
import confetti from "canvas-confetti";
import CreateOrderModal from "./CreateOrderModal"; // By omkar
import CancelShipmentModal from "./CancelShipmentModal"; // By omkar

const defaultFilterData = {
  retailerId: "",
  consigneeName: "",
  consigneeMobile: "",
  fromDate: "",
  toDate: "",
};

const OrderMaster = () => {
  const pageSize = 10;
  const { user } = useSelector((state) => state.auth);

  const [noData, setNoData] = useState(false);
  const [editData, setEditData] = useState({});
  const [orderData, setOrderData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [columnData, setColumnData] = useState("");
  const [rowData, setRowData] = useState(null);
  const [showProductDetail, setShowProductDetail] = useState(false);
  const [productDetail, setProductDetail] = useState([]);
  const [isModalOpenReport, setIsModalOpenReport] = useState(false);
  const [isModalOpenReportDown, setIsModalOpenReportDown] = useState(false);
  const [downloadReportData, setDownloadReportData] = useState([]);
  const [loadingFullSt, setLoadingFullSt] = useState(false);
  const [loadingDowRep, setLoadingDowRep] = useState(false);
  const [noDowRepData, setNoDowRepData] = useState(false);
  const [pageDowRepDetails, setPageDowRepDetails] = useState(null);

  //By OMKAR
  const [isCancelShipmentModalOpen, setIsCancelShipmentModalOpen] =
    useState(false);

  const openModalReport = () => {
    setIsModalOpenReport(true);
  };

  const closeModalReport = () => {
    setIsModalOpenReport(false);
  };

  const openModalReportDown = () => {
    setIsModalOpenReportDown(true);
  };

  const closeModalReportDown = () => {
    setIsModalOpenReportDown(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    fetchOrderData(1, defaultFilterData);
  };

  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  useEffect(() => {
    fetchOrderData(1, filterData);
  }, []);

  const fetchOrderData = async (currentPage, filters = filterData) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        retailerId: filters.retailerId || "",
        consigneeName: filters.consigneeName || "",
        consigneeMobile: filters.consigneeMobile || "",
        fromDate: formatDate(filters.fromDate),
        toDate: formatDate(filters.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_ORDER_MASTER_DATA}?pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setOrderData(modifiedData);
        setNoData(modifiedData?.length === 0);
      } else {
        setNoData(true);
        setOrderData([]);
        CustomAlert({
          title: "Failed",
          text: response?.data?.message || "Failed to fetch data",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      setNoData(true);
      setOrderData([]);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const formattedCreDate = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;
      return {
        ...user,
        id: index + 1,
        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",
      };
    });
    return modified;
  };

  const orderHeader = [
    "Products",
    "Status",
    "Response",
    "Waybill",
    "Retailer Id",
    "Retailer Name",
    "Consignee Name",
    "Mobile No",
    "Phone No",
    "Email Id",
    "Address Line 1",
    "Address Line 2",
    "Address Type",
    "Pincode",
    "City",
    "State",
    "Country",
    "Invoice Number",
    "Payment Mode",
    "Express Type",
    "Order Amount (₹)",
    "COD Amount (₹)",
    "Shipment Weight",
    "Shipment Length",
    "Shipment Width",
    "Shipment Height",
    "Pick Address ID",
    "Return Address ID",
    "Seller ID",
    "E-Way Bill Number",
    "Route Code",
    "Carrier",
    "Created Date",
  ];

  const orderHeaderToKeyMap = {
    Products: "products",
    Status: "orderStatus",
    Response: "response",
    Waybill: "waybill",
    "Retailer Id": "retailerId",
    "Retailer Name": "retailerName",
    "Consignee Name": "consigneeName",
    "Mobile No": "consigneeMobile",
    "Phone No": "consigneePhone",
    "Email Id": "consigneeEmailId",
    "Address Line 1": "consigneeAddress1",
    "Address Line 2": "consigneeAddress2",
    "Address Type": "addressType",
    Pincode: "consigneePincode",
    City: "consigneeCity",
    State: "consigneeState",
    Country: "consigneeCountry",
    "Invoice Number": "invoiceNumber",
    "Payment Mode": "paymentMode",
    "Express Type": "expressType",
    "Order Amount (₹)": "orderAmount",
    "COD Amount (₹)": "codAmount",
    "Shipment Weight": "shipmentWeight",
    "Shipment Length": "shipmentLength",
    "Shipment Width": "shipmentWidth",
    "Shipment Height": "shipmentHeight",
    "Pick Address ID": "pickAddressId",
    "Return Address ID": "returnAddressId",
    "Seller ID": "sellerId",
    "E-Way Bill Number": "ewaybillNumber",
    "Route Code": "routeCode",
    Carrier: "carrier",
    "Created Date": "createdDate",
  };

  const handleAuthorization = (data) => {
    console.log("::data::", data);
  };

  const handleCustomer = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);
    if (actionType === "add") {
      setEditData({});
      openModalCreate(true);
      setIsModalOpenCreate(true); // By OMKAR
    } else if (actionType === "cancelShipment") {
      // By OMKAR
      setIsCancelShipmentModalOpen(true); // By OMKAR
    } else if (actionType === "auth") {
      let custData = orderData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    } else {
      let custData = orderData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  const handleProductDetails = (data) => {
    if (data?.products && data?.products.length > 0) {
      setProductDetail(data?.products);
    } else {
      setProductDetail([]);
    }
    setShowProductDetail(true);
  };

  const handleFullStatement = async (fromDate, toDate) => {
    try {
      setLoadingFullSt(true);
      const payload = {
        username: user?.data?.username,
        fromDate,
        toDate,
      };

      const response = await axiosPostApi(
        `${apiList.ORDER_MASTER_DOWNLOAD_HISTORY}`,
        payload
      );

      if (response.status === 200 && response.data.status === true) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message || "Success",
          icon: "success",
          confirmButtonText: "Ok",
        });
        closeModalReport();

        const canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.zIndex = "3000";
        document.body.appendChild(canvas);

        const confettiInstance = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        confettiInstance({
          particleCount: 250,
          spread: 100,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          document.body.removeChild(canvas);
        }, 3000);
      } else {
        setNoData(true);
        fetchOrderData(1, filterData);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "Failed",
            text: response?.data?.message || "Failed",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
      setLoadingFullSt(false);
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
      setLoadingFullSt(false);
    }
  };

  const handleDownloadReport = async (currentPage) => {
    setLoadingDowRep(true);
    setNoDowRepData(false);

    try {
      const requestBody = {
        username: user?.data?.username,
      };

      const response = await axiosPostApi(
        `${apiList.ORDER_MASTER_DOWNLOAD_HISTORY_LIST}?pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (response && response.data) {
        if (response.data.status === true && response.data.respCode === "00") {
          const downloadHistory = response.data.data;
          setPageDowRepDetails(response.data.pageDetails);
          setDownloadReportData(downloadHistory || []);

          if (!downloadHistory || downloadHistory.length === 0) {
            setNoDowRepData(true);
          } else {
            setNoDowRepData(false);
          }
        } else {
          setDownloadReportData([]);
          setNoDowRepData(true);

          CustomAlert({
            title: "Failed",
            text: response.data.message || "Failed to fetch data",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      } else {
        setDownloadReportData([]);
        setNoDowRepData(true);
      }
    } catch (error) {
      console.error("Error fetching download history:", error);
      setDownloadReportData([]);
      setNoDowRepData(true);

      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoadingDowRep(false);
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <MasterTable
              loading={loading}
              headers={orderHeader}
              data={orderData}
              handleAction={handleCustomer}
              filterFields={["consigneeName"]}
              entityType="Order"
              headerToKeyMap={orderHeaderToKeyMap}
              handleAuth={handleAuthorization}
              noData={noData}
              pageDetails={pageDetails}
              currentPage={currentPage}
              pageSize={pageSizeCount}
              totalRecord={totalRecord}
              fetchNextData={(page) => fetchOrderData(page, filterData)} // Pass filterData
              setCurrentPage={setCurrentPage}
              openModalFilter={openModalFilter}
              handleReset={handleReset}
              filterData={filterData}
              fetchData={() => {}}
              handleProductDetails={handleProductDetails}
              setRowData={setRowData}
              openModalSms={openModalReport}
              openModalSmsDown={openModalReportDown}
            />
          </>
        )}

        {isModalOpenFilter ? (
          <OrderFilterModal
            show={isModalOpenFilter}
            handleClose={closeModalFilter}
            setOrderData={setOrderData}
            setPageDetails={setPageDetails}
            setNoData={setNoData}
            currentPage={currentPage}
            pageSize={pageSize}
            filterData={filterData}
            setFilterData={setFilterData}
            handleReset={handleReset}
          />
        ) : null}

        {isModalOpenReport ? (
          <FullStatement
            handleopenReport={isModalOpenReport}
            handleCloseReport={closeModalReport}
            callApi={handleFullStatement}
            loading={loadingFullSt}
          />
        ) : null}
        {isModalOpenReportDown ? (
          <DownloadReport
            handleopenReportDown={isModalOpenReportDown}
            handleCloseReportDown={closeModalReportDown}
            callApi={handleDownloadReport}
            data={downloadReportData}
            pageDowRepDetails={pageDowRepDetails}
            noData={noDowRepData}
            loading={loadingDowRep}
          />
        ) : null}

        <ProductDetailsModal
          show={showProductDetail}
          handleClose={() => setShowProductDetail(false)}
          productDetail={productDetail}
        />

        {isModalOpenCreate && ( //By OMKAR
          <CreateOrderModal
            show={isModalOpenCreate}
            handleClose={() => setIsModalOpenCreate(false)}
            refreshTable={() => fetchOrderData(currentPage, filterData)} 
          />
        )}

        {isCancelShipmentModalOpen && ( //By OMKAR
          <CancelShipmentModal
            show={isCancelShipmentModalOpen}
            handleClose={() => setIsCancelShipmentModalOpen(false)}
            refreshTable={() => fetchOrderData(currentPage, filterData)}
          />
        )}
      </div>
    </>
  );
};

export default OrderMaster;
